document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".custom-banner-slider", {
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
    });
  new Swiper(".brand-slider", {
      loop: true,
      slidesPerView: 1,
    a11y: false,
      spaceBetween: 0,
      navigation: {
        nextEl: ".brand-slider .swiper-button-next",
        prevEl: ".brand-slider .swiper-button-prev",
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        575: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
        1280: { slidesPerView: 5 }
      }
    });
  new Swiper(".custom_featured_collection", {
      loop: true,
    a11y: false,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: ".custom_featured_collection .swiper-button-next",
        prevEl: ".custom_featured_collection .swiper-button-prev",
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        575: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 4 },
        1280: { slidesPerView: 5 }
      }
    });
  new Swiper(".popcat_cover", {
      loop: true,
      slidesPerView: 1,
    a11y: false,
      spaceBetween: 0,
      navigation: {
        nextEl: ".popcat_cover .swiper-button-next",
        prevEl: ".popcat_cover .swiper-button-prev",
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        575: { slidesPerView: 2 },
        991: { slidesPerView: 3 }
      }
    });
  
    initializeRelatedProductsSwiper();
  });
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".related-products-slider .swiper-wrapper");
  if (container && container.children.length > 0) {
    initializeRelatedProductsSwiper();
  }
});

// Related Product Slider (Swiper version)
function initializeRelatedProductsSwiper() {
  const container = document.querySelector(".related-products-slider");

  // Only initialize if the slider exists and isn't already initialized
  if (!container || container.classList.contains("swiper-initialized")) return;

  new Swiper(".related-products-slider", {
    loop: true,
    a11y: false,
    slidesPerView: 1,
    spaceBetween: 0,
    centerMode: false,
    centeredSlides:false,
    navigation: {
      nextEl: ".related-products-slider .swiper-button-next",
      prevEl: ".related-products-slider .swiper-button-prev",
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
     575: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
      1280: { slidesPerView: 5 }
    }
  });

  // Mark as initialized
  container.classList.add("swiper-initialized");
}

// Check periodically if the related-products-slider content has loaded
const checkRelatedProductsInterval = setInterval(function () {
  const container = document.querySelector(".related-products-slider .swiper-wrapper");
  if (container && container.children.length > 0) {
    initializeRelatedProductsSwiper();
    clearInterval(checkRelatedProductsInterval);
  }
}, 100); // Check every 100ms


// Show the second element with class "main-banner"
const mainBanner = document.querySelectorAll('.main-banner')[1];
if (mainBanner) {
  mainBanner.style.display = 'block';
}

// Show the second element with class "popcat-section"
const popcatSection = document.querySelectorAll('.popcat-section')[1];
if (popcatSection) {
  popcatSection.style.display = 'block';
}

// Show the second element with class "brand_logo"
const brandLogo = document.querySelectorAll('.brand_logo')[1];
if (brandLogo) {
  brandLogo.style.display = 'block';
}

// Show all submenu wrappers inside hover-menu
document.addEventListener("DOMContentLoaded", function () {
  const submenus = document.querySelectorAll(".hover-menu .submenu_wrapper");
  submenus.forEach(submenu => {
    submenu.style.display = "block";
  });
});



// Show the see more button and product description on the product page
document.addEventListener('DOMContentLoaded', function () {
  const descriptions = document.querySelectorAll('.custom-product-description');
  descriptions.forEach((wrapper) => {
    const content = wrapper.querySelector('.product__description');
    const btn = wrapper.querySelector('.custom-product-description__toggle');
    if (!content || !btn) return;
    const lineHeight = parseFloat(window.getComputedStyle(content).lineHeight);
    const maxHeight = lineHeight * 5;

    // Only show Read More if content is more than 5 lines
    if (content.scrollHeight > maxHeight + 5) {
      content.classList.add('is-collapsed');
      btn.style.display = 'inline-block';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const isExpanded = content.classList.contains('is-expanded');
        if (isExpanded) {
          content.classList.remove('is-expanded');
          content.classList.add('is-collapsed');
          btn.innerText = '+ Read More';
          const stickyHeader =
            document.querySelector('.header-wrapper') ||
            document.querySelector('sticky-header');

          const headerHeight = stickyHeader
            ? stickyHeader.getBoundingClientRect().height
            : 0;
          const wrapperTop =
            wrapper.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({
            top: wrapperTop - headerHeight - 20,
            behavior: 'smooth',
          });
        } else {
          content.classList.remove('is-collapsed');
          content.classList.add('is-expanded');
          btn.innerText = '− Read Less';
        }
      });
    }
  });
});

// custom accordian
var acc = document.getElementsByClassName("accordion");

// Open first accordion by default
if (acc.length > 0) {
  var firstPanel = acc[0].nextElementSibling;

  acc[0].classList.add("active");
  firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";
}

// Accordion click event
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    // If already active then do nothing
    if (this.classList.contains("active")) {
      return;
    }

    // Close all accordions
    for (var j = 0; j < acc.length; j++) {
      acc[j].classList.remove("active");

      var panel = acc[j].nextElementSibling;
      panel.style.maxHeight = null;
    }

    // Open current accordion
    this.classList.add("active");

    var activePanel = this.nextElementSibling;
    activePanel.style.maxHeight = activePanel.scrollHeight + "px";
  });
}